module.exports = __webpack_public_path__ + "media/images/vector-18@2x-3f1641fe089c8f3f59ccdb02b5574edd.png";